import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { clearMessageHistory } from '../utils/MessageHistory.js';
import { useChatTabsContext } from '../contexts/ChatTabsContext';
export const useClearChatsOnRouteChange = () => {
  const location = useLocation();
  const { setTabs } = useChatTabsContext();
  const prevPathRef = useRef(location.pathname);
  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currentPath = location.pathname;
    const cameFromSpecialPage =
      prevPath.startsWith('/optimizer-list') || prevPath.startsWith('/summarize');
    const nowOnSpecialPage =
      currentPath.startsWith('/optimizer-list') || currentPath.startsWith('/summarize');
    if (cameFromSpecialPage && !nowOnSpecialPage) {
      try {
        clearMessageHistory();
        setTabs([]);
      } catch (error) {
        console.log(error);
      }
    }
    prevPathRef.current = currentPath;
  }, [location.pathname, setTabs]);
};
